import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { ListResult } from '~src/httpClient/fetchers/ListResult';
import { FilterOps } from '~src/spacesPlatform/models/IFilterClause';
import { SiteRoles } from '~src/userManagement/users/serverApi/types/ISiteRole';
import { ISiteUser } from '~src/userManagement/users/serverApi/types/ISiteUser';

import { WebClientListResourceFetcher } from '../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import {
  GetSiteUsersRequest,
  IGetSiteUsersParams,
  IGetSiteUsersResult
} from '../users/serverApi/requests/GetSiteUsersRequest';

class GetSiteAdminsResource {

  private siteUsersFetcher = new WebClientListResourceFetcher(GetSiteUsersRequest, (result: IGetSiteUsersResult) => result.users);

  public getSiteAdmins(): Promise<ListResult<ISiteUser>> {
    const siteUserParams: IGetSiteUsersParams = {
      filter: {
        clauses: [ServerFilterClauses.SiteRole([
          SiteRoles.SiteAdministratorCreator,
          SiteRoles.ServerAdministrator,
          SiteRoles.SiteAdministratorExplorer
        ])],
        operator: FilterOps.eq
      }
    };
    return this.siteUsersFetcher.fetchList(siteUserParams);
  }
}

export const GetSiteAdmins = new GetSiteAdminsResource();
